import React, {Component} from 'react'
import {Card} from 'antd'
import ReportBalanceCompany from './ReportBalanceCompany'
import TableBalanceCompany from './TableBalanceCompany'

class BalanceCompany extends Component {
  render() {
    return (
      <Card title="Reporte por Compañia">
        <ReportBalanceCompany />
        <br />
        <TableBalanceCompany />
      </Card>
    )
  }
}

export default BalanceCompany



// WEBPACK FOOTER //
// ./src/routes/main/Reports/balanceCompany/index.js